import { BriefcaseOutlineIcon } from './BriefcaseOutlineIcon';

/**
 * author: Google
 * id 1E7F3689-287C-40DC-B0DD-CF65987E9B53
 * name briefcase-outline
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/briefcase-outline.svg
 * tags
 */
export const WorkOutlineIcon = BriefcaseOutlineIcon;
export default WorkOutlineIcon